/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  TelemetryWindowPayload,
  TelemetryWindowPayload$Outbound,
  TelemetryWindowPayload$outboundSchema,
} from "../components/telemetrywindowpayload.js";

export type QueryTumDetailsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type QueryTumDetailsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  telemetryWindowPayload: TelemetryWindowPayload;
};

/** @internal */
export type QueryTumDetailsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const QueryTumDetailsSecurity$outboundSchema: z.ZodMiniType<
  QueryTumDetailsSecurity$Outbound,
  QueryTumDetailsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function queryTumDetailsSecurityToJSON(
  queryTumDetailsSecurity: QueryTumDetailsSecurity,
): string {
  return JSON.stringify(
    QueryTumDetailsSecurity$outboundSchema.parse(queryTumDetailsSecurity),
  );
}

/** @internal */
export type QueryTumDetailsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  TelemetryWindowPayload: TelemetryWindowPayload$Outbound;
};

/** @internal */
export const QueryTumDetailsRequest$outboundSchema: z.ZodMiniType<
  QueryTumDetailsRequest$Outbound,
  QueryTumDetailsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    telemetryWindowPayload: TelemetryWindowPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      telemetryWindowPayload: "TelemetryWindowPayload",
    });
  }),
);

export function queryTumDetailsRequestToJSON(
  queryTumDetailsRequest: QueryTumDetailsRequest,
): string {
  return JSON.stringify(
    QueryTumDetailsRequest$outboundSchema.parse(queryTumDetailsRequest),
  );
}
